import { createSelector } from 'reselect';

export const isLoading = createSelector(
  state => state.atg__coupons,
  coupons => coupons.isLoading,
);

export const getUrls = createSelector(
  state => state.atg__coupons,
  coupons => coupons.urlsByCriteria,
);

export const getErrors = createSelector(
  state => state.atg__coupons,
  coupons => coupons.errorsByCriteria,
);
